module.exports = __webpack_public_path__ + "assets/images/issue-emerald.svg?d19c9438c4a1f687d8915973cc70eaf1";


//////////////////
// WEBPACK FOOTER
// ./_source/images/notifications/issue-emerald.svg
// module id = 631
// module chunks = 0